// extracted by mini-css-extract-plugin
export default {"addButton":"RespondentExaminations_addButton__5EF3b","searchBlock":"RespondentExaminations_searchBlock__Kkv3X","examinationsBlock":"RespondentExaminations_examinationsBlock__X7ILq"};